import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { CaseServiceCause } from "./case-service-cause";

export enum CaseServiceReasonType {
    Cancel = "Cancel",
    DelayedDate = "DelayedDate"
}

export class CaseServiceReason extends Resource {
    public override type = 'caseServiceReasons';

    @prop()
    @required()
    public name!: string;

    @prop()
    public caseServiceReasonType: CaseServiceReasonType  = CaseServiceReasonType.DelayedDate;
   
    
    @prop()
    @required()
    public caseServiceCauseId!: string;

    public caseServiceCause?: CaseServiceCause;
}